export enum Role {
    NONE,
    SUPER_ADMIN,
    GUEST,
}
